import { API, getRequest, putRequest } from '@/api/api';

import type {
  NotificationDelivery,
  NotificationDeliveryDto,
  NotificationDeliveryOption,
} from './notification-delivery.types';

const mapNotificationDelivery = ({
  user_id,
  delivery_option,
  created_at,
  updated_at,
}: NotificationDeliveryDto): NotificationDelivery => ({
  userId: user_id,
  deliveryOption: delivery_option,
  createdAt: created_at,
  updatedAt: updated_at,
});

export const getNotificationDelivery = async (): Promise<NotificationDelivery> => {
  const { data } = await getRequest<NotificationDeliveryDto>(
    API.NOTIFICATIONS,
    'notifications/settings/delivery',
  );
  return mapNotificationDelivery(data);
};

export const updateNotificationDelivery = async (
  deliveryOption: NotificationDeliveryOption,
): Promise<NotificationDelivery> => {
  const { data } = await putRequest<NotificationDeliveryDto, unknown>(
    API.NOTIFICATIONS,
    'notifications/settings/delivery',
    { delivery_option: deliveryOption },
  );
  return mapNotificationDelivery(data);
};
